import { GeocoderService } from '@/core/services/geocoder.service'
import { GeocoderI } from '../interfaces/geocoder.interface'

const geocoderService = new GeocoderService()

import { YandexGeocodeResponseT, TwoGisGeocodeResponseT, YandexGeocodeOptions } from '@/core/types/geocoder.types'

class GeocoderRealisation implements GeocoderI {
    async geocode(options: YandexGeocodeOptions): Promise<YandexGeocodeResponseT> {
        return geocoderService.geocode(options)
    }

    yandexGeocode(geocode: string, bbox: number[][] | null): Promise<YandexGeocodeResponseT> {
        return geocoderService.yandexGeocode(geocode, bbox)
    }

    twoGisGeocodeByCoords(coordinates: number[]): Promise<TwoGisGeocodeResponseT> {
        return geocoderService.twoGisGeocodeByCoords(coordinates)
    }

    twoGisGeocodeByAddress(address: string, coordinates: number[][] | null): Promise<TwoGisGeocodeResponseT> {
        return geocoderService.twoGisGeocodeByAddress(address, coordinates)
    }
}

export const geocoder = new GeocoderRealisation()
